// libs
import React, { useState, memo } from "react";
import { SerializedStyles } from "@emotion/core";

// global components
import WithStyles from "shared/components/WithStyles";
import IOElement from "shared/components/IOElement";
import Portal from "shared/components/Portal";

// helpers
import { cssMerge } from "shared/helpers/utils";

// styles
import { fadeIn } from "shared/styles/animations/fadeIn";
import { scrollToTopCss, ioCss } from "./styles";

// defs
interface IScrollToTopProps {
    cssProps?: SerializedStyles | SerializedStyles[];
}

const ScrollToTop = ({ cssProps }: IScrollToTopProps) => {
    const [showScroll, setShowScroll] = useState(false);

    const scrollToTop = () => {
        window.requestAnimationFrame(() => {
            // If page bottom is too away straight away scroll to top
            if (window.pageYOffset < window.innerHeight * 25) {
                var $el = document.getElementById("app");
                $el && $el.scrollIntoView({ behavior: "smooth", block: "start" });
            } else {
                window.scrollTo(0, 0);
            }
        });
    };

    return (
        <Portal>
            <IOElement
                css={ioCss}
                onHidden={() => setShowScroll(true)}
                onVisible={() => setShowScroll(false)}
            />
            {showScroll && (
                <WithStyles
                    cssProps={cssMerge([scrollToTopCss, fadeIn], cssProps)}
                    as="button"
                    aria-label="scroll-up"
                    onClick={scrollToTop}
                    data-test="scrollButton"
                >
                    <i className="icon-back icon" />
                </WithStyles>
            )}
        </Portal>
    );
};

export default memo(ScrollToTop);
